import React, { useRef } from "react";
import Slider from "react-slick";
import { isEmpty } from "lodash";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useNavigate } from "react-router-dom";
import { hotGameData } from "../../constraints/constants";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import GameSliderHeader from "../../components/GameSliderHeader";

const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  autoplay: false,
  arrows: false,
  slidesToScroll: 3,
  centerPadding: "10px",
  slidesToShow: 3,
  rows: 2,
  slidesPerRow: 1,
};

const HotGameSlider = () => {
  const sliderRef = useRef(null);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const launchCasino = useContextSelector(AuthContext, (ctx) => ctx.launchCasino);
  const navigate = useNavigate();

  return (
    <>
      <GameSliderHeader title="HOT GAMES" to="/casino?header=hotgame" sliderRef={sliderRef} />
      <div className="hotgame-slider border-0 p-0">
        <div>
          <Slider ref={sliderRef} {...settings}>
            {hotGameData?.map((item) => (
              <div
                key={item?.casinoType || item?.img}
                onClick={() => {
                  if (!isEmpty(user)) {
                    launchCasino({
                      platForm: item?.platForm || item?.platFormCode,
                      gameType: item?.gameType,
                      casinoType: item?.casinoType,
                    });
                  } else {
                    navigate("/login");
                  }
                }}
                className="slider-items"
              >
                <figure className="mb-0 shine">
                  <ImageWithPlaceholder src={item?.img || item?.image} alt="" />
                </figure>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HotGameSlider;
